/**
 * Generated by orval v6.28.2 🍺
 * Do not edit manually.
 * Maybern
 * Maybern API
 * OpenAPI spec version: 0.0.0
 */
import {
  z as zod
} from 'zod'

/**
 * Returns a JWT token for a user
 */
export const tokenCreateBody = zod.object({
  "email": zod.string().min(1),"password": zod.string().min(1)
})

export const tokenCreateResponseClientsAnnotationsSetMin = 2;
export const tokenCreateResponseClientsAnnotationsSetMax = 2;

export const tokenCreateResponse = zod.object({
  "access": zod.string().min(1),"refresh": zod.string().min(1),"user_id": zod.string().min(1),"email": zod.string().min(1),"first_name": zod.string().min(1),"last_name": zod.string().min(1),"clients": zod.array( zod.object({
  "annotations_set": zod.array(zod.array(zod.any()).min(tokenCreateResponseClientsAnnotationsSetMin).max(tokenCreateResponseClientsAnnotationsSetMax)).optional(),"name": zod.string().min(1),"domain": zod.string().min(1),"created_at": zod.string().datetime().or(zod.union([zod.null(), zod.literal("")])).optional(),"web_domain": zod.string().or(zod.union([zod.null(), zod.literal("")])).optional(),"id": zod.string().min(1).or(zod.union([zod.null(), zod.literal("")])).optional(),"enable_delete_protection": zod.boolean().optional(),"is_maybern_customer": zod.boolean().optional(),"state": zod.enum(['draft', 'active', 'archived', ""]).optional()
})),"intercom_user_hash": zod.string().optional()
})

/**
 * Returns a JWT token for a user
 */
export const tokenRefreshCreateBody = zod.object({
  "refresh": zod.string().min(1)
})

export const tokenRefreshCreateResponseClientsAnnotationsSetMin = 2;
export const tokenRefreshCreateResponseClientsAnnotationsSetMax = 2;

export const tokenRefreshCreateResponse = zod.object({
  "access": zod.string().min(1),"refresh": zod.string().min(1),"clients": zod.array( zod.object({
  "annotations_set": zod.array(zod.array(zod.any()).min(tokenRefreshCreateResponseClientsAnnotationsSetMin).max(tokenRefreshCreateResponseClientsAnnotationsSetMax)).optional(),"name": zod.string().min(1),"domain": zod.string().min(1),"created_at": zod.string().datetime().or(zod.union([zod.null(), zod.literal("")])).optional(),"web_domain": zod.string().or(zod.union([zod.null(), zod.literal("")])).optional(),"id": zod.string().min(1).or(zod.union([zod.null(), zod.literal("")])).optional(),"enable_delete_protection": zod.boolean().optional(),"is_maybern_customer": zod.boolean().optional(),"state": zod.enum(['draft', 'active', 'archived', ""]).optional()
}))
})

/**
 * Obtain a JWT token from a Stytch token
 */
export const tokenStytchCreateBody = zod.object({
  "stytch_token": zod.string().min(1)
})

export const tokenStytchCreateResponseClientsAnnotationsSetMin = 2;
export const tokenStytchCreateResponseClientsAnnotationsSetMax = 2;

export const tokenStytchCreateResponse = zod.object({
  "access": zod.string().min(1),"refresh": zod.string().min(1),"user_id": zod.string().min(1),"email": zod.string().min(1),"first_name": zod.string().min(1),"last_name": zod.string().min(1),"clients": zod.array( zod.object({
  "annotations_set": zod.array(zod.array(zod.any()).min(tokenStytchCreateResponseClientsAnnotationsSetMin).max(tokenStytchCreateResponseClientsAnnotationsSetMax)).optional(),"name": zod.string().min(1),"domain": zod.string().min(1),"created_at": zod.string().datetime().or(zod.union([zod.null(), zod.literal("")])).optional(),"web_domain": zod.string().or(zod.union([zod.null(), zod.literal("")])).optional(),"id": zod.string().min(1).or(zod.union([zod.null(), zod.literal("")])).optional(),"enable_delete_protection": zod.boolean().optional(),"is_maybern_customer": zod.boolean().optional(),"state": zod.enum(['draft', 'active', 'archived', ""]).optional()
})),"intercom_user_hash": zod.string().optional()
})

